import { Injectable } from '@angular/core';
import { MasterDataService } from './master-data.service';

@Injectable({ providedIn: 'root' })
export class RoleMenuService {
  constructor(private masterDataService: MasterDataService) {}

  /**
   * Returns true if the user can access the given menu name (case-sensitive)
   */
  canAccessMenu(menuName: string): boolean {
    const masterData = this.masterDataService.getMasterData();
    const menuPermissions = masterData?.employee?.role?.menuPermissions || [];
    return menuPermissions.some((perm: any) => perm.menu.menuName === menuName && perm.canView);
  }

  /**
   * Returns the list of menu names the user can view
   */
  getAllowedMenus(): string[] {
    const masterData = this.masterDataService.getMasterData();
    const menuPermissions = masterData?.employee?.role?.menuPermissions || [];
    return menuPermissions.filter((perm: any) => perm.canView).map((perm: any) => perm.menu.menuName);
  }

  /**
   * Returns true if the user's role is Admin (code SA, or legacy ADMIN). Role assignments do not count.
   */
  isAdmin(): boolean {
    const roleCode = this.masterDataService.getMasterData()?.employee?.role?.roleCode;
    return ['SA', 'ADMIN'].includes(String(roleCode ?? '').toUpperCase());
  }

  /**
   * Returns the full menu permission objects for advanced use
   */
  getMenuPermissions(): any[] {
    const masterData = this.masterDataService.getMasterData();
    return masterData?.employee?.role?.menuPermissions || [];
  }
}
